export default __webpack_public_path__ + "static/media/NityaBefore1.b63503d6.png";